var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[Object.keys(fn)[0]])(fn = 0)), res;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[Object.keys(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __reExport = (target, module, desc) => {
  if (module && typeof module === "object" || typeof module === "function") {
    for (let key of __getOwnPropNames(module))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module[key], enumerable: !(desc = __getOwnPropDesc(module, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module) => {
  return __reExport(__markAsModule(__defProp(module != null ? __create(__getProtoOf(module)) : {}, "default", module && module.__esModule && "default" in module ? { get: () => module.default, enumerable: true } : { value: module, enumerable: true })), module);
};

// node_modules/tsup/assets/esm_shims.js
import { fileURLToPath } from "url";
import path from "path";
var init_esm_shims = __esm({
  "node_modules/tsup/assets/esm_shims.js"() {
  }
});

// node_modules/tailwindcss/lib/util/createPlugin.js
var require_createPlugin = __commonJS({
  "node_modules/tailwindcss/lib/util/createPlugin.js"(exports) {
    init_esm_shims();
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;
    function createPlugin(plugin, config) {
      return {
        handler: plugin,
        config
      };
    }
    createPlugin.withOptions = function(pluginFunction, configFunction = () => ({})) {
      const optionsFunction = function(options) {
        return {
          __options: options,
          handler: pluginFunction(options),
          config: configFunction(options)
        };
      };
      optionsFunction.__isOptionsFunction = true;
      optionsFunction.__pluginFunction = pluginFunction;
      optionsFunction.__configFunction = configFunction;
      return optionsFunction;
    };
    var _default = createPlugin;
    exports.default = _default;
  }
});

// node_modules/tailwindcss/lib/public/create-plugin.js
var require_create_plugin = __commonJS({
  "node_modules/tailwindcss/lib/public/create-plugin.js"(exports) {
    init_esm_shims();
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;
    var _createPlugin = _interopRequireDefault(require_createPlugin());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    var _default = _createPlugin.default;
    exports.default = _default;
  }
});

// node_modules/tailwindcss/plugin.js
var require_plugin = __commonJS({
  "node_modules/tailwindcss/plugin.js"(exports, module) {
    init_esm_shims();
    var createPlugin = require_create_plugin();
    module.exports = (createPlugin.__esModule ? createPlugin : { default: createPlugin }).default;
  }
});

// src/index.ts
var require_src = __commonJS({
  "src/index.ts"(exports, module) {
    init_esm_shims();
    var import_plugin = __toModule(require_plugin());
    module.exports = (0, import_plugin.default)(() => {
    }, {
      theme: {
        extend: {
          screens: {
            "can-hover": { raw: "(hover:hover)" },
            "cannot-hover": { raw: "(hover:none)" },
            "pointer-fine": { raw: "(pointer:fine)" },
            "pointer-coarse": { raw: "(pointer:coarse)" },
            "pointer-none": { raw: "(pointer:none)" },
            "any-can-hover": { raw: "(any-hover:hover)" },
            "any-cannot-hover": { raw: "(any-hover:none)" },
            "none-can-hover": { raw: "not all and (any-hover:hover)" },
            "any-pointer-coarse": { raw: "(any-pointer:coarse)" },
            "any-pointer-fine": { raw: "(any-pointer:fine)" },
            "no-pointer-coarse": { raw: "not all and (any-pointer:coarse)" },
            "no-pointer-fine": { raw: "not all and (any-pointer:fine)" },
            "no-pointer": { raw: "(any-pointer:none)" },
            "only-touch": { raw: "(any-pointer:coarse) and (any-hover:none) { @media not all and (any-pointer:fine) {}}" },
            "only-cursor": { raw: "(any-pointer:fine) and (any-hover:hover) { @media not all and (any-pointer:coarse) {}}" },
            "touch+cursor": { raw: "(any-pointer:coarse) and (any-pointer:fine) and (any-hover: hover)" }
          }
        }
      }
    });
  }
});
export default require_src();
//# sourceMappingURL=index.mjs.map